import ThisModule from "./ModalAcceptTerms";

export default ThisModule;
